export const firebase = {
    authDomain: "fixably-signature-app.firebaseapp.com",
    databaseURL: "https://fixably-signature-app-default-rtdb.firebaseio.com",
    projectId: "fixably-signature-app",
    storageBucket: "fixably-signature-app.appspot.com",
    messagingSenderId: "1007479362039",
    appId: "1:1007479362039:web:ff9b2a714165276c425ef2",
    measurementId: "G-7L0PE5SJFK"
};
